<template>
  <Newsletter />
  <footer data-section="contact">
    <div class="content --footer">
      <OpeningHours :content="$beet.options.footer.opening_hours" v-reveal />
      <OpeningHours :content="$beet.options.footer.kitchen" v-reveal="{ delay: 200 }" />
      <ContactDetails :content="$beet.options.footer.contact" v-reveal="{ delay: 250 }" />
    </div>
    <FooterCredits />
  </footer>
</template>

<script>
import ContactDetails from '@/components/blocks/ContactDetails.vue'
import FooterCredits from '@/components/blocks/FooterCredits.vue'
import Newsletter from '@/components/blocks/Newsletter.vue'
import OpeningHours from '@/components/blocks/OpeningHours.vue'

export default {
  name: 'Footer',
  components: { ContactDetails, FooterCredits, Newsletter, OpeningHours },
}
</script>
